var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState, useEffect, useCallback, } from 'react';
import ReactDOM from 'react-dom';
//@ts-ignore
import { useDebouncedCallback } from 'use-debounce';
import { ChevronDown, ChevronRight } from '@shared/icons/icons';
import { ContextMenuBox, ContextMenuContainer, ContextSubMenuBox, ContextMenuBoxItem, ContextMenuLabel, ContextMenuVerticalHr, ContextMenuHorizontalHr, } from '@styled/ContextMenu';
var DEBOUNCE_DELAY = 333;
var INITIAL_STATE = {
    left: -window.innerWidth,
    top: 0,
    show: false,
};
function calculatePosition(e, menuSize) {
    var clientX = e.clientX, clientY = e.clientY;
    var _a = e.target.getBoundingClientRect(), x = _a.x, y = _a.y;
    var menuWidth = menuSize.menuWidth, menuHeight = menuSize.menuHeight;
    var innerWidth = window.innerWidth, innerHeight = window.innerHeight;
    var X = e.type === 'click' ? x : clientX;
    var Y = e.type === 'click' ? y : clientY;
    var left = X;
    var top = Y;
    if (menuWidth && X + menuWidth > innerWidth) {
        left = X - (innerWidth - (innerWidth - menuWidth));
    }
    if (menuHeight && Y + menuHeight > innerHeight) {
        top = Y - (innerHeight - (innerHeight - menuHeight));
    }
    return { top: top, left: left, show: true };
}
function calcSubmenuPosition(subMenu, itemHeight, menuDirection) {
    var position;
    var rect = subMenu === null || subMenu === void 0 ? void 0 : subMenu.getBoundingClientRect();
    if (!rect) {
        return position;
    }
    if (menuDirection === 'horizontal') {
        position = __assign({}, position);
    }
    if (rect.x + rect.width > window.innerWidth) {
        // menu is too far right
        position = __assign(__assign({}, position), { left: "calc(-".concat(rect.width, "px + 1%)") });
    }
    if (rect.y + rect.height > window.innerHeight) {
        // menu is too low
        position = __assign(__assign({}, position), { transform: "translateY(calc(-50% + ".concat(itemHeight, "px / 2))") });
    }
    return position;
}
function ContextMenuItem(_a) {
    var item = _a.item, shownMenuItems = _a.shownMenuItems, onMenuShow = _a.onMenuShow, closeMenu = _a.closeMenu, menuDirection = _a.menuDirection, preventDefault = _a.preventDefault;
    var menuItem = useRef(null);
    var subMenuRef = useRef(null);
    var _b = __read(useState(null), 2), shownSubMenu = _b[0], setShownSubMenu = _b[1];
    var _c = __read(useState(), 2), position = _c[0], setPosition = _c[1];
    useEffect(function () {
        var _a;
        setShownSubMenu(null);
        setPosition(calcSubmenuPosition(subMenuRef.current, (_a = menuItem.current) === null || _a === void 0 ? void 0 : _a.offsetHeight, menuDirection));
    }, [shownMenuItems]);
    var debouncedSetShownSubmenu = useDebouncedCallback(function (menu) {
        //@ts-ignore
        setShownSubMenu(menu !== null && menu !== void 0 ? menu : null);
    }, DEBOUNCE_DELAY);
    var isSubMenuShown = shownMenuItems && item.items === shownMenuItems;
    var subMenu = item.items && isSubMenuShown ? (React.createElement(ContextSubMenuBox, { ref: subMenuRef, style: position, "$direction": "vertical", "$menuDirection": menuDirection }, item.items.map(function (i, idx) {
        if (i.spacer) {
            return menuDirection === 'vertical' ? (React.createElement(ContextMenuVerticalHr, { key: "spacer-".concat(idx) })) : (React.createElement(ContextMenuHorizontalHr, { key: "spacer-".concat(idx) }));
        }
        else {
            return (React.createElement(ContextMenuItem, { key: "".concat(item.actionName, "-").concat(JSON.stringify(idx)), item: i, onMenuShow: debouncedSetShownSubmenu, shownMenuItems: shownSubMenu, closeMenu: closeMenu, menuDirection: menuDirection, preventDefault: preventDefault }));
        }
    }))) : null;
    var chevron = item.items ? menuDirection === 'vertical' ? React.createElement(ChevronRight, null) : React.createElement(ChevronDown, null) : null;
    var Icon = item.icon;
    var Component = item.Component;
    return (React.createElement(React.Fragment, null,
        React.createElement(ContextMenuBoxItem, { ref: menuItem, onKeyDown: function (e) {
                e.key === 'Enter' && Component && closeMenu();
            }, onMouseDown: preventDefault ? function (e) { return e.preventDefault(); } : undefined, onClick: function (e) {
                var _a;
                e.stopPropagation();
                (_a = item.action) === null || _a === void 0 ? void 0 : _a.call(item, e);
                item.action && closeMenu();
            }, onMouseEnter: function () { return onMenuShow(item.items); }, "$isComponent": !!item.Component, "$isDisabled": !!item.isDisabled, "$iconOnly": item.icon !== undefined && item.actionName === undefined },
            Icon && React.createElement(Icon, { destructive: item.destructive, creative: item.creative, disabled: item.isDisabled }),
            item.actionName && (React.createElement(ContextMenuLabel, { "$creative": item.creative, "$destructive": item.destructive, "$disabled": item.isDisabled, "$fillIconSpace": Icon === undefined }, item.actionName)),
            Component && React.createElement(Component, { style: { marginLeft: Icon ? '8px' : '16px' } }),
            chevron,
            subMenu),
        item.break && (menuDirection === 'vertical' ? React.createElement(ContextMenuVerticalHr, null) : React.createElement(ContextMenuHorizontalHr, null))));
}
function ContextMenu(_a) {
    var items = _a.items, triggerRefs = _a.triggerRefs, onClose = _a.onClose, onOpen = _a.onOpen, _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.direction, direction = _c === void 0 ? 'vertical' : _c, _d = _a.preventDefault, preventDefault = _d === void 0 ? false : _d;
    var menuRef = useRef(null);
    var _e = __read(useState(null), 2), shownSubMenu = _e[0], setShownSubMenu = _e[1];
    var _f = __read(useState(__assign({}, INITIAL_STATE)), 2), contextMenuData = _f[0], setContextMenuData = _f[1];
    var show = contextMenuData.show, top = contextMenuData.top, left = contextMenuData.left;
    var closeMenu = useCallback(function (e) {
        var _a, _b;
        var targetNode = e === null || e === void 0 ? void 0 : e.target;
        if (((_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.contains(targetNode)) ||
            ((_b = menuRef.current) === null || _b === void 0 ? void 0 : _b.isEqualNode(targetNode)) ||
            menuRef.current === targetNode) {
            return;
        }
        setContextMenuData(__assign({}, INITIAL_STATE));
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose, INITIAL_STATE]);
    useEffect(function () {
        var _a, _b;
        var listeners = [];
        var _loop_1 = function (i) {
            var triggerRef = triggerRefs[i];
            var closeIfOtherMenuOpens = function (e) {
                var parentNode = triggerRef.ref.current;
                var targetNode = e.target;
                if (!parentNode || !targetNode) {
                    closeMenu(e);
                    return;
                }
                if (parentNode.contains(targetNode)) {
                    return;
                }
                closeMenu(e);
            };
            var openMenu = function (e) {
                onClose === null || onClose === void 0 ? void 0 : onClose();
                e.preventDefault();
                setTimeout(function () {
                    var _a, _b;
                    setContextMenuData(calculatePosition(e, {
                        menuWidth: (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth,
                        menuHeight: (_b = menuRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight,
                    }));
                    onOpen === null || onOpen === void 0 ? void 0 : onOpen(e);
                }, 10);
            };
            listeners[i] = { openMenu: openMenu, closeIfOtherMenuOpens: closeIfOtherMenuOpens };
            (_a = triggerRef.ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener((_b = triggerRef.trigger) !== null && _b !== void 0 ? _b : 'contextmenu', listeners[i].openMenu, true);
            window.addEventListener('contextmenu', listeners[i].closeIfOtherMenuOpens, true);
            window.addEventListener('mousedown', closeMenu, true);
        };
        for (var i = 0; i < triggerRefs.length; i++) {
            _loop_1(i);
        }
        return function () {
            var _a, _b;
            for (var i = 0; i < triggerRefs.length; i++) {
                var triggerRef = triggerRefs[i];
                (_a = triggerRef.ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener((_b = triggerRef.trigger) !== null && _b !== void 0 ? _b : 'contextmenu', listeners[i].openMenu, true);
                window.removeEventListener('contextmenu', listeners[i].closeIfOtherMenuOpens, true);
                window.removeEventListener('mousedown', closeMenu, true);
            }
        };
    }, [closeMenu, onOpen]);
    useEffect(function () {
        setShownSubMenu(null);
    }, [show, top, left]);
    var debouncedSetShownSubmenu = useDebouncedCallback(function (menu) {
        //@ts-ignore
        setShownSubMenu(menu !== null && menu !== void 0 ? menu : null);
    }, DEBOUNCE_DELAY);
    var menuItems = items.map(function (i, index) {
        if (i.spacer) {
            return direction === 'vertical' ? (React.createElement(ContextMenuVerticalHr, { key: "spacer-".concat(index) })) : (React.createElement(ContextMenuHorizontalHr, { key: "spacer-".concat(index) }));
        }
        else {
            return (React.createElement(ContextMenuItem, { key: index, item: i, shownMenuItems: shownSubMenu, onMenuShow: debouncedSetShownSubmenu, closeMenu: closeMenu, menuDirection: direction, preventDefault: preventDefault }));
        }
    });
    var extraStyle = show && visible ? {} : { visibility: 'hidden', left: '-100%' };
    var menu = (React.createElement(ContextMenuBox, { ref: menuRef, style: extraStyle, "$direction": direction }, menuItems));
    return show
        ? ReactDOM.createPortal(React.createElement(ContextMenuContainer, { style: { left: left, top: top }, className: "context-menu" }, menu), document.getElementById('portal'))
        : menu;
}
export default ContextMenu;
